<div class="uploader-box">
  <button
    type="button"
    class="upload-btn"
    (click)="onClick($event)"
    [disabled]="disabled"
  >
    <i class="fas fa-link"></i>
    <span>{{ chooseLabel }}</span>
    <div *ngIf="required" style="color: red; display: inline">*</div>
  </button>
  <!-- <rp *ngIf="!required">{{"optional" | translate}}</rp> -->
  <input
    #fileUpload
    type="file"
    class="input_fileupload--hidden"
    (change)="onFileSelected($event)"
    [multiple]="multiple"
    accept="{{ this.accept }}"
  />
  <div class="file-validation">{{ this.invalidFileMessageDetail }}</div>
  <div class="spinner-border spinner-border-sm" role="status" *ngIf="isLoading">
    <span class="sr-only">Loading...</span>
  </div>
  <div class="row">
    <!-- <div class="col-md-4" *ngFor="let f of files">
      <div class="file">
        <span>{{ f.name }}</span>
        <div class="left-info">
          <div
            class="spinner-border spinner-border-sm"
            role="status"
            *ngIf="isLoading"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <button
            class="btn"
            mat-icon-button
            [attr.title]="deleteButtonLabel ? deleteButtonLabel : null"
            (click)="removeFile(f)"
          >
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div> -->
  </div>
  <div class="row scrollable" *ngIf="attachmentFiles?.length > 0">
    <div class="col-md-4" *ngFor="let f of attachmentFiles">
      <div class="file">
        <span [title]="f.label ? f.label : f.name">{{
          truncateLabelText(f.label ? f.label : f.name)
        }}</span>
        <div class="left-info">
          <button
            class="btn"
            type="button"
            mat-icon-button
            [attr.title]="deleteButtonLabel ? deleteButtonLabel : null"
            (click)="removeFileRemotly(f.id)"
          >
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
